/* ==========================================================================
   tk-menu-defer.js — odložené dotažení mega menu a podpanelů mobilního draweru
   ==========================================================================

   PROČ
   Hlavička se rendruje na KAŽDÉ stránce webu a vnitřek navigace v ní zabíral
   ~519 kB HTML (mega panely ~424 kB, podpanely draweru ~94 kB), které leží ve
   streamu PŘED hlavním obsahem stránky. Nikdo je přitom většinou neotevře.

   CO ZŮSTÁVÁ V HTML (kostra)
   - <li class="tk-nav__item tk-nav__item--has-mega"> + odkaz první úrovně
   - .tk-mega__backdrop, .tk-mobile-toggle, .tk-mobile-drawer__backdrop
   - kořen .tk-mobile-drawer + jeho HLAVNÍ panel (11 odkazů + patička)
   Bez JS tedy pořád fungují všechny odkazy první úrovně.

   CO SE DOTAHUJE
   - `.tk-mega` panely (vnitřek každé položky menu)
   - `.tk-drawer-panel` mimo hlavní panel

   JAK
   Section Rendering API: GET <root_url>?section_id=<PLNÉ section.id>&view=megamenu
   - ⚠️ PLNÉ section.id (sections--…__header_section). Krátké jméno „header"
     vrátí sekci s DEFAULT nastavením a bez bloků → panely bez produktů.
   - ⚠️ ŽÁDNÁ hlavička Accept. S `Accept: application/json` vrátí Shopify
     produktové JSON místo sekce.
   - `view=megamenu` → templates/index.megamenu.json → template.suffix je
     'megamenu' → header.liquid vypíše i vnitřek panelů.
   - `country=` musí být v URL, jinak se ceny vyrenderují v primárním trhu.
   - URL staví Liquid z routes.root_url, takže na /en a /sk dorazí správná
     jazyková verze menu.

   CACHE
   sessionStorage, klíč nese jazyk + trh + verzi assetu. TTL 30 minut, protože
   v panelech jsou ceny a skladovost (viz TTL_MS níž).

   PO INJEKTÁŽI se musí znovu zavolat inicializace z header.liquid:
   window.__tkBindMega, __tkInitMegaBrands, __tkInitDrawer, __tkNavEqualize.
   Všechny jsou idempotentní.
   ========================================================================== */
(function () {
  var mount = document.querySelector('[data-tk-menu-url]');
  if (!mount || !window.DOMParser) return;

  var url = mount.getAttribute('data-tk-menu-url');
  var cacheKey = mount.getAttribute('data-tk-menu-key') || '';
  if (!url) return;

  /* Ceny a skladovost produktů v panelech nesmí zestárnout na celou session
     (uživatel může mít kartu otevřenou hodiny a menu by ukazovalo jinou cenu
     než PDP). 30 minut pokryje běžnou návštěvu bez jediného refetche a přitom
     drží odchylku v mezích, ve kterých kolísá i Shopify full-page cache. */
  var TTL_MS = 30 * 60 * 1000;

  var inFlight = false;
  var done = false;

  /* ---- sessionStorage: může házet výjimku UŽ PŘI PŘÍSTUPU (Safari private
     mode, zablokované úložiště, iframe bez povolení) → try/catch všude. ---- */
  function cacheGet() {
    if (!cacheKey) return null;
    try {
      var raw = window.sessionStorage.getItem(cacheKey);
      if (!raw) return null;
      var obj = JSON.parse(raw);
      if (!obj || !obj.t || !obj.h || (Date.now() - obj.t) > TTL_MS) {
        try { window.sessionStorage.removeItem(cacheKey); } catch (e) {}
        return null;
      }
      return obj.h;
    } catch (e) {
      return null;
    }
  }

  function cacheSet(html) {
    if (!cacheKey) return;
    try {
      window.sessionStorage.setItem(cacheKey, JSON.stringify({ t: Date.now(), h: html }));
    } catch (e) {
      /* Plná kvóta nebo vypnuté úložiště → prostě necachujeme. Zkusíme aspoň
         uklidit případný starý záznam, ať tam neleží mrtvá kopie. */
      try { window.sessionStorage.removeItem(cacheKey); } catch (e2) {}
    }
  }

  /* ---- Z odpovědi Section Rendering API vytáhni JEN panely a slož z nich
     kompaktní, cachovatelný tvar. Zbytek hlavičky (styly, skripty, ikony)
     zahodíme — do stránky se nesmí dostat podruhé. ---- */
  function normalize(doc) {
    var out = '';
    var items = doc.querySelectorAll('.tk-header__nav .tk-nav__item');
    for (var i = 0; i < items.length; i++) {
      var panels = items[i].querySelectorAll(':scope > .tk-mega');
      if (!panels.length) continue;
      var inner = '';
      for (var j = 0; j < panels.length; j++) inner += panels[j].outerHTML;
      out += '<div data-tk-mega="' + i + '">' + inner + '</div>';
    }
    var subs = doc.querySelectorAll('.tk-mobile-drawer > .tk-drawer-panel:not(.tk-drawer-panel--main)');
    if (subs.length) {
      var d = '';
      for (var k = 0; k < subs.length; k++) d += subs[k].outerHTML;
      out += '<div data-tk-drawer>' + d + '</div>';
    }
    return out;
  }

  /* ---- Vložení do živého DOMu. DOMParser dokument je INERTNÍ — obrázky se
     nestahují a skripty nespouštějí, dokud uzly neadoptujeme. ---- */
  function apply(html) {
    if (done || !html) return false;

    var doc;
    try {
      doc = new DOMParser().parseFromString('<!doctype html><body>' + html + '</body>', 'text/html');
    } catch (e) {
      return false;
    }

    var liveItems = document.querySelectorAll('.tk-header__nav .tk-nav__item');
    var groups = doc.querySelectorAll('[data-tk-mega]');
    var placed = 0;

    for (var i = 0; i < groups.length; i++) {
      var idx = parseInt(groups[i].getAttribute('data-tk-mega'), 10);
      var live = liveItems[idx];
      if (!live || live.querySelector('.tk-mega')) continue;
      var kids = Array.prototype.slice.call(groups[i].children);
      for (var j = 0; j < kids.length; j++) {
        live.appendChild(document.importNode(kids[j], true));
      }
      placed++;
    }

    var drawerGroup = doc.querySelector('[data-tk-drawer]');
    /* Drawer si header.liquid při inicializaci přesouvá na <body>. Po morphu
       hlavičky (cart:update) může v sekci vzniknout druhá, nepřipojená kopie —
       vždycky mířit na tu na body. */
    var drawer = document.body.querySelector(':scope > .tk-mobile-drawer') || document.querySelector('.tk-mobile-drawer');
    if (drawerGroup && drawer && !drawer.querySelector('.tk-drawer-panel:not(.tk-drawer-panel--main)')) {
      var dkids = Array.prototype.slice.call(drawerGroup.children);
      for (var k = 0; k < dkids.length; k++) {
        drawer.appendChild(document.importNode(dkids[k], true));
      }
      placed++;
    }

    if (!placed) return false;
    done = true;

    if (window.__tkBindMega) window.__tkBindMega();
    if (window.__tkInitMegaBrands) window.__tkInitMegaBrands();
    if (window.__tkInitDrawer) window.__tkInitDrawer();
    if (window.__tkNavEqualize) window.__tkNavEqualize();
    document.dispatchEvent(new CustomEvent('tk:menu-ready'));

    /* Když panely dorazí ve chvíli, kdy kurzor UŽ leží na položce menu,
       mouseenter se sám znovu nespustí → panel by se otevřel až po odjetí
       a návratu. Doťukneme ho synteticky. */
    try {
      var hot = document.querySelector('.tk-header__nav .tk-nav__item--has-mega:hover');
      if (hot) {
        var link = hot.querySelector('.tk-nav__link');
        if (link) link.dispatchEvent(new MouseEvent('mouseenter', { bubbles: false }));
      }
    } catch (e) {}

    return true;
  }

  function load() {
    if (done || inFlight) return;

    var cached = cacheGet();
    if (cached && apply(cached)) return;

    inFlight = true;
    /* ⚠️ Žádný Accept header — viz hlavička souboru. */
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        inFlight = false;
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var norm = normalize(doc);
        if (!norm) {
          if (window.console && console.warn) {
            console.warn('[tk-menu-defer] Section Rendering nevrátil žádné panely. Existuje templates/index.megamenu.json a projde přes ?view=megamenu?');
          }
          return;
        }
        if (apply(norm)) cacheSet(norm);
      })
      .catch(function () { inFlight = false; });
  }
  window.__tkMenuLoad = load;

  /* ---- Spouštěče: co nastane dřív ---- */
  var nav = document.querySelector('.tk-header__nav');
  if (nav) {
    nav.addEventListener('pointerenter', load, { capture: true, once: true });
    nav.addEventListener('focusin', load, { once: true }); // klávesnice (Tab)
  }
  var toggle = document.querySelector('.tk-mobile-toggle');
  if (toggle) {
    toggle.addEventListener('pointerdown', load, { once: true });
    toggle.addEventListener('focus', load, { once: true });
  }

  function idle() {
    if (window.requestIdleCallback) {
      window.requestIdleCallback(load, { timeout: 2500 });
    } else {
      setTimeout(load, 400);
    }
  }
  if (document.readyState === 'complete') {
    idle();
  } else {
    window.addEventListener('load', idle, { once: true });
  }
  setTimeout(load, 6000); // pojistka, kdyby `load` nikdy nedoběhl

  /* Horizon po přidání do košíku hlavičku PŘEMORFUJE z čerstvého renderu —
     ten je v odloženém režimu bez panelů, takže by injektované panely zmizely.
     Doplníme je znovu; z cache je to bez síťového requestu. */
  document.addEventListener('cart:update', function () {
    requestAnimationFrame(function () {
      var item = document.querySelector('.tk-header__nav .tk-nav__item--has-mega');
      if (!item || item.querySelector('.tk-mega')) return;
      done = false;
      load();
    });
  });
})();
